import axios from 'axios';
import BaseUrl from '../util/BaseUrl';

const API_URL = BaseUrl.baseUrl+"api/reward-point";

const getAllRewardPoint = async () => {
    try {
        const response = await axios.get(API_URL+'/all');
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to getting reward Point');
    }
};

const getRewardPointById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to getting reward Point');
    }
};

const createRewardPoint = async (dto, token) => {
    try {
        const response = await axios.post(API_URL+'/create', dto, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to create Reward Point');
    }
};

const updateRewardPoint = async (id, dto, token) => {
    try {
        const response = await axios.put(`${API_URL}/update/${id}`, dto, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to updating Reward Point');
    }
};

const deleteRewardPoint = async (id, token) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response ? error.response.data.message : 'Failed to delete Reward Point');
    }
};

const RewardPointService = {
    getAllRewardPoint,
    getRewardPointById,
    deleteRewardPoint,
    createRewardPoint,
    updateRewardPoint
};

export default RewardPointService;